import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "app-export",
	templateUrl: "./export.component.html",
	styleUrls: ["./export.component.scss"],
})
export class ExportComponent {
	@Input() disabled: boolean;
	@Input() disableAllExport = false;
	@Input() showDetailedExport = false;
	@Input() showAllExport = false;
	@Output() csvExportReport = new EventEmitter();
	@Output() detailedPDFExportReport? = new EventEmitter();
	@Output() pdfExportReport = new EventEmitter();
	@Output() allCSVExportReport = new EventEmitter();

	public exportCSV() {
		this.csvExportReport.emit();
	}

	public exportDetailedPDF() {
		this.detailedPDFExportReport.emit();
	}

	public exportPDF() {
		this.pdfExportReport.emit();
	}

	public exportAllCSV() {
		this.allCSVExportReport.emit();
	}
}
